<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-12 forms-block">
                                <!-- Pay Type -->
                                <!-- <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Department :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="departmentId" name="departmentId"
                                            label="text"
                                            @input="changedValue"
                                            :options="departmentArr" :clearable=false placeholder="Select Department">
                                        </v-select>
                                        <div class="help is-danger">{{departmentIdError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div> -->

                                <!-- Empolyee Name -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Employee Name :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" @input="empolyee_name_error = ''" maxlength="190" class="form-control" v-model="empolyee_name" id="empolyee_name" placeholder="Enter Employee Name" name="empolyee_name" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{empolyee_name_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- Date of Request -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Date of Request :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <date-picker @input="date_of_request_error = ''" placeholder="DD/MM/YYYY" id="date_of_request" name="date" v-model="date_of_request" :config="options" aria-describedby="basic-addon1" :disabled="$route.params.id ? true : false"></date-picker>
                                        <div class="help is-danger">{{date_of_request_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                
                                <!-- Full RA# -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Full RA# :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" @input="full_ra_error = ''" maxlength="190" class="form-control" v-model="full_ra" id="full_ra" placeholder="Enter Full RA" name="full_ra" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{full_ra_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- DATE RA WAS ORIGINALLY CLOSED -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">DATE RA WAS ORIGINALLY CLOSED :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <date-picker @input="date_ra_was_originally_closed_error = ''" placeholder="DD/MM/YYYY" id="date_ra_was_originally_closed" name="date" v-model="date_ra_was_originally_closed" :config="options" aria-describedby="basic-addon1" :disabled="$route.params.id ? true : false"></date-picker>
                                        <div class="help is-danger">{{date_ra_was_originally_closed_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- Pay Type -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Pay Type :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="pay_type" name="pay_type"
                                            label="text"
                                            :options="pay_type_arr" :clearable="false" :disabled="$route.params.id ? true : false">
                                        </v-select>
                                    </div>
                                </div>
                                
                                <!-- Location -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Location :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="location" name="location"
                                            label="name" placeholder="Select Location" @input="location_error = ''"
                                            :options="locationArr" :clearable="false" :disabled="$route.params.id ? true : false">
                                        </v-select>
                                        <div class="help is-danger">{{location_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- REASON REVERSAL IS REQUIRED -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">REASON REVERSAL IS REQUIRED :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="reason" name="reason" id="reason"
                                            label="text" placeholder="Select"
                                            @input="reason_error = ''"
                                            :options="reasonArr" :clearable="false" :disabled="$route.params.id ? true : false">
                                        </v-select>
                                        <div class="help is-danger">{{reason_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                    <!-- <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea type="text" @input="reason_error = ''" class="form-control" v-model="reason" id="reason" name="reason"></textarea>
                                        <div class="help is-danger">{{reason_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div> -->
                                </div>

                                <!-- Comments -->
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">COMMENTS :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea type="text" class="form-control" v-model="comments" id="comments" name="comments" :disabled="$route.params.id ? true : false"></textarea>
                                    </div>
                                </div>

                                <!-- Status -->
                                <div class="common-form-field" v-show="status_field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">STATUS :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <v-select v-model="status" name="status"
                                            label="name" placeholder="Select Status"
                                            :options="statusArr" :clearable=false>
                                        </v-select>
                                    </div>
                                </div>
                                <!-- How much time in vs billed? -->
                                <div v-if="isWarrantySelect" class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">How much time in vs Billed? :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" @input="howMuchTimeBilledError = ''" class="form-control" v-model="howMuchTimeBilled" id="howMuchTimeBilled" name="howMuchTimeBilled" :disabled="$route.params.id ? true : false">
                                        <div class="help is-danger">{{howMuchTimeBilledError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>

                                <!-- What is the Tech's Efficiency MTD? -->
                                <div v-if="isWarrantySelect" class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">What is the Tech's Efficiency MTD? :</div>
                                    </div>
                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <textarea type="text" @input="questions_error = ''" class="form-control" v-model="questions" id="questions" name="questions" :disabled="$route.params.id ? true : false"></textarea>
                                        <div class="help is-danger">{{questions_error}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <!-- <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addRoReversalData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button> -->
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addRoReversalData('save')"><span id="createAttachment">Save</span></button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'UserAddForm',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add RO Reversal Request',
                edit_id: 0,
                departmentArr: [ 
                    {
                        text: 'Service',
                        value: 'Service',
                    },
                    {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                ],
                reasonArr: [ 
                    {
                        text: 'Billed to incorrect customer',
                        value: 'Billed to incorrect customer',
                    },
                    {
                        text: 'Part/labour coding error',
                        value: 'Part/labour coding error',
                    },
                    {
                        text: 'EOM – Uncollected',
                        value: 'EOM – Uncollected',
                    },
                    {
                        text: 'Incorrect sale type',
                        value: 'Incorrect sale type',
                    },
                    {
                        text: 'MISC charge',
                        value: 'MISC charge',
                    },
                    {
                        text: 'Tech time',
                        value: 'Tech time',
                    },
                    {
                        text: 'Incorrect Billing',
                        value: 'Incorrect Billing',
                    },
                    {
                        text: 'No warranty coverage',
                        value: 'No warranty coverage',
                    },
                    {
                        text: 'Closed in Error',
                        value: 'Closed in Error',
                    },
                    {
                        text: 'Incorrect vehicle information',
                        value: 'Incorrect vehicle information',
                    },
                    {
                        text: 'Policy',
                        value: 'Policy',
                    },
                    {
                        text: 'Billed incorrect amount',
                        value: 'Billed incorrect amount',
                    },
                ],
                departmentId: "",
                departmentIdError: "",
                empolyee_name: "",
                empolyee_name_error: "",
                options: {
                    format: 'DD/MM/YYYY',
                },
                statusArr: [],
                status: "",
                status_field: false,
                date_of_request: "",
                date_of_request_error: "",
                full_ra: "",
                full_ra_error: "",
                date_ra_was_originally_closed: "",
                date_ra_was_originally_closed_error: "",
                pay_type: {text: "Customer Pay",value: "Customer Pay"},
                pay_type_arr: [
                    {
                        text: "Customer Pay",
                        value: "Customer Pay",
                    },
                    {
                        text: "Warranty",
                        value: "Warranty",
                    },
                ],
                location: "",
                locationArr: [],
                location_error: "",
                reason: "",
                reason_error: "",
                comments: "",
                questions: "",
                questions_error: "",
                howMuchTimeBilled: "",
                howMuchTimeBilledError: "",
                isWarrantySelect: false,
                managerEmail: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
            }
        },
        watch: {
            pay_type: function(pay_type) {
                self.isWarrantySelect = false;
                if(pay_type.value == 'Warranty') {
                    self.isWarrantySelect = true;
                }
            },
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.locationArr.length;index++) {
                        var obj = self.locationArr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("ROReversalRequest");
            self.showLoader();

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }

            // self.loadLocation();
            // self.loadBodyShopLocation();
            self.loadLocationFromZone();

            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit RO Reversal Request';
                    self.getROReversalRequestById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                } else {
                    self.hideLoader();
                }
            });
        },
        methods: {
            buttonBack() {
                self.$router.push('/roreversal/list');
            },
            changedValue: function (department) {
                self.departmentIdError = "";
                self.locationArr = [];
                self.location = "";
                if (department != 'undefined' && department.value) {
                    self.locationArr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.locationArr = self.bodyShopLocationArr;
                    }
                }
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        // slug: "vvg-au",
                        // department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                /* if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                } */
                                if(objLocation['name'] == 'Las Vegas, NV' || objLocation['id'] == 3) {
                                    self.bodyShopLocationArr[index]['manager_email'] += ",greyes@vvgtruck.com";
                                }
                            }
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        // console.log(JSON.stringify(self.bodyShopLocationArr));
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        // slug: "vvg-au",
                        // department_id: 2
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            self.locationArr = response.data.locations;
                            // self.serviceLocationArr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadLocationFromZone() {
                var config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/get/locations", config)
                    .then(function (response) {
                        self.locationArr = response.data.content;
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                    });
            },
            getROReversalRequestById() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.edit_id
                    }
                };
                self.showLoader();
                HTTP.get("/ro-reversal-request/get", config)
                        .then(function (response) {
                            if(response.data.content != '') {
                                // Show The Status While Edit
                                self.status_field = true;
                                self.empolyee_name = response.data.content.empolyee_name;
                                self.date_of_request = response.data.content.date_of_request;
                                self.full_ra = response.data.content.full_ra;
                                self.date_ra_was_originally_closed = response.data.content.date_ra;
                                self.pay_type = {text: response.data.content.pay_type, value: response.data.content.pay_type};
                                if(response.data.content.pay_type == 'Warranty') {
                                    self.isWarrantySelect = true;
                                }
                                self.location = {name: response.data.content.location, id: response.data.content.location};
                                self.reason = {text: response.data.content.reason, value: response.data.content.reason};
                                self.comments = response.data.content.comments;
                                self.questions = response.data.content.questions;
                                self.howMuchTimeBilled = response.data.content.billed_time;
                                self.status = {name: response.data.content.status, value: response.data.content.status};
                                if(response.data.content.status == 'In Progress') {
                                    self.statusArr = [{
                                                        name: 'In Progress',
                                                        value: 'In Progress',
                                                    },
                                                    {
                                                        name: 'Completed',
                                                        value: 'Completed',
                                                    }];
                                }else{
                                    self.statusArr = [{
                                                        name: 'Completed',
                                                        value: 'Completed',
                                                    },
                                                    {
                                                        name: 'In Progress',
                                                        value: 'In Progress',
                                                    }
                                                    ];
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.empolyee_name_error = "";
                self.date_of_request_error = "";
                self.full_ra_error = "";
                self.date_ra_was_originally_closed_error = "";
                self.location_error = "";
                self.reason_error = "";
                self.questions_error = "";
                self.howMuchTimeBilledError = "";
                self.departmentIdError = "";

                // if (self.departmentId == null || !self.departmentId.value) {
                //     self.departmentIdError = "Select Department";
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                if (!self.empolyee_name) {
                    self.empolyee_name_error = "Please enter employee name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date_of_request) {
                    self.date_of_request_error = "Select Date of Request";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.full_ra) {
                    self.full_ra_error = "Please enter Full RA";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date_ra_was_originally_closed) {
                    self.date_ra_was_originally_closed_error = "Select Date RA was originally Closed Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.reason) {
                    self.reason_error = "Please select reason";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.isWarrantySelect) {
                    if (!self.questions) {
                        self.questions_error = "Please enter question";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if(self.isWarrantySelect) {
                    if (!self.howMuchTimeBilled) {
                        self.howMuchTimeBilledError = "Please enter Billed time";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            addRoReversalData(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            manager_email: self.managerEmail,
                            empolyee_name: self.empolyee_name,
                            date_of_request: self.date_of_request,
                            full_ra: self.full_ra,
                            date_ra_was_originally_closed: self.date_ra_was_originally_closed,
                            pay_type: self.pay_type.value,
                            location: self.location.id,
                            locationName: self.location.name,
                            reason: self.reason.value,
                            comments: self.comments,
                            questions: self.questions,
                            howMuchTimeBilled: self.howMuchTimeBilled,
                            departmentName: self.departmentId.value,
                            id: self.edit_id,
                            status: self.status.value,
                        };
                        // self.showLoader();
                        HTTP.post("/ro-reversal-request/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    if (flag == 'save') {
                                        if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                            self.buttonBack();
                                        } else {
                                            self.empolyee_name = '';
                                            self.date_of_request = '';
                                            self.full_ra = '';
                                            self.date_ra_was_originally_closed = '';
                                            self.pay_type = {text: "Customer Pay", value: "Customer Pay"};
                                            self.location = '';
                                            self.reason = '';
                                            self.comments = '';
                                            self.isWarrantySelect = false;
                                            self.questions = '';
                                            self.howMuchTimeBilled = '';
                                            self.manager_email = '';
                                            self.status = '';
                                        }
                                    } else {                                        
                                        self.empolyee_name = '';
                                        self.date_of_request = '';
                                        self.full_ra = '';
                                        self.date_ra_was_originally_closed = '';
                                        self.pay_type = {text: "Customer Pay", value: "Customer Pay"};
                                        self.location = '';
                                        self.reason = '';
                                        self.comments = '';
                                        self.isWarrantySelect = false;
                                        self.questions = '';
                                        self.howMuchTimeBilled = '';
                                        self.manager_email = '';
                                        self.status = '';
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Forms/ROReversalRequest/AddUpdateROReversalRequest.vue